import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalDateTimeRange } from '../../type/shared';
export class SealedSegments {
}
__decorate([
    Type(() => LocalDateTimeRange),
    __metadata("design:type", Array)
], SealedSegments.prototype, "sealedSegments", void 0);
